import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  Branch,
  LandingProduct,
  ProductBranch,
  ProductWrapper,
  SubBranch,
} from "@app/modules/home/models/portal.model";
import {
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { DataReload, DataService } from "@app/services/data.service";
import { DynamicYieldTaggingService, LoaderService } from "@app/services";

import { BaseComponent } from "@app/base/base.component";
import { CampaignService } from "@services/campaign.service";
import { CommonModalCoverageAndExclusionsComponent } from "@app/components/common-modal-coverage-and-exclusions/common-modal-coverage-and-exclusions.component";
import { ErrorListService } from "@services/error-list.service";
import { GoogleAnalyticServiceService } from "@app/helpers/google-analytic-service.service";
import { Location } from "@angular/common";
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from "@angular/material/stepper";
import { ModalComponent } from "@app/components/modal/modal.component";
import { PortalService } from "@app/modules/home/services/portal.service";
import { ProductPageRouteService } from "@app/services/product-page-route.service";
import { ProductService } from "@services/product.service";
import { RangeAgesFieldService } from "@services/range-ages-field.service";
import { ResponseTitleComponent } from "@app/components/response-title/response-title.component";
import { SaleStatus } from "@app/models/campaign.model";
import { ScheduleCallFieldService } from "@services/schedule-call-field.service";
import { SendgridService } from "@services/sendgrid.service";
import { SeoService } from "@app/services/seo.service";
import { StyleService } from "@app/services/style/style.service";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { TitleModalConfig } from "@shared/title-modal-config";
import { environment } from "@environments/environment";
import { replaceSpaces } from "@app/helpers/utils";
import { GtmTaggingService } from "@app/services/gtm-tagging.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  providers: [ScheduleCallFieldService],
})
export class HomeComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild("homestepper") private stepper: MatStepper;
  saleObject: SaleStatus = this.campaignService.getSaleStatus();
  fields: any[];
  rangeAgesFields: any[];
  showTinyHouse: boolean = false;
  branchSelected: Branch;
  subBranchSelected: SubBranch;
  productsFromSubBranch: ProductBranch[];
  productsSelected: any[] = [];
  submitSrvFn: any;
  urlProductosVida: string;
  modeCallCenter: string = "CALLCENTER";
  modeF2F: string = "F2F";

  public configSwiper: SwiperConfigInterface;
  public portalMode: string;
  public branches: Branch[];
  public subBranches: SubBranch[];
  public productShip: LandingProduct;
  public productsHome: ProductBranch[];
  public amountCompare: number;

  constructor(
    public renderer: Renderer2,
    private router: Router,
    private location: Location,
    private errorListService: ErrorListService,
    public campaignService: CampaignService,
    private portalService: PortalService,
    public productService: ProductService,
    service: ScheduleCallFieldService,
    rangeAgesService: RangeAgesFieldService,
    private sendgridService: SendgridService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private seoService: SeoService,
    private loaderService: LoaderService,
    private dataService: DataService,
    private googleAnalyticService: GoogleAnalyticServiceService,
    private gtmTaggingService: GtmTaggingService,
    private productPageRouteService: ProductPageRouteService,
    private dynamicYieldTaggingService: DynamicYieldTaggingService,
    private styleService: StyleService
  ) {
    super(renderer);
    this.seoService.updateTitle(
      ` Portal de Seguros Banco Guayaquil | Chubb Seguros`
    );
    this.seoService.updateMetaTags([
      {
        name: "description",
        content:
          "Banco Guayaquil se alió con Chubb Seguros para ofrecerte la más amplia variedad de seguros y los mejores precios. ¡Cotiza online y asegúrate en segundos!",
      },
    ]);
    this.fields = service.getFields();
    this.rangeAgesFields = rangeAgesService.getFields();
    this.route.url.subscribe((url) => {
      if (url.length) {
        this.urlProductosVida = `/${url[0].path}`;
      }
    });
  }

  ngOnInit(): void {
    const payloadInit = this.campaignService.payloadGuard;
    if (payloadInit) {
      this.campaignService.sendLoaderNoInterceptor(true);
      this.campaignService.getDraftData(payloadInit).subscribe(
        data => {
          if (data?.redirectUrl) {
            const params = this.route.snapshot.queryParams;
            const url = new URL(location.href);
            this.campaignService.setParamsData(params);
            this.router.navigateByUrl(`${data.redirectUrl}${url?.search}`);
            this.campaignService.sendLoaderNoInterceptor(false)
            return;
          } else {
            this.initHome();
          }
        },
        err => {
          console.error(err);
          this.gtmTaggingService.gtmError(err?.message || err);
          this.campaignService.resetData();
          this.campaignService.removeBGCampaignParams();
          this.getRootBranches();
        },
        () => this.campaignService.sendLoaderNoInterceptor(false)
      )
    } else {
      this.initHome();
    }
    
  }

  ngOnChanges(changes: SimpleChanges) {}

  ngOnDestroy() {
    this.campaignService.sendLoaderNoInterceptor(false);
  }

  initHome() {
    this.styleService.load('bootstrap').then(data => {
    }).catch(error => console.log(error));
    this.campaignService.sendLoaderNoInterceptor(true);
    this.productPageRouteService.sendLayoutMessage();
    this.campaignService.resetAdditionalData();
    this.productService.resetProducts();
    this.portalService.validationMessage$.subscribe((msg) => {
      this.productsHome = this.portalService.getProductsFromSearchData();
    });

    const cookies = document.cookie;
    // const domain = '.chubb.com'; // Prod
    const domain = environment.domainDy; //'localhost'; // Local
    if (cookies !== null) {
       const split = document.cookie.split(';');
       for (const val of split) {
          const nameValue = val.split('=');
          nameValue[0] = nameValue[0].replace(/^ /, '');
          const cookieName = nameValue[0];
          const cookieValue = nameValue[1];
          if (cookieName === "_dyid") {
             let expires = '';
             const date = new Date();
             date.setTime(date.getTime() + (31556926000));
             expires = '; expires=' + date.toUTCString();
             document.cookie = "_dyid_server" + '=' + (cookieValue || '') + (expires || '') + '; path=/; domain=' + domain + '; secure;SameSite=Lax';
          }
       }
    }

    if (
      this.route.snapshot?.queryParams &&
      Object.keys(this.route.snapshot.queryParams).length
    ) {
      const params = this.route.snapshot.queryParams;
      const campaignResolve = this.route.snapshot.data["campaignResolve"];
      this.campaignService.setParamsData(params);
      let paramsObj = { ...params };
      if (campaignResolve?.product_id) {
        if (params[CampaignService.SALE_QPARAMS.VS]) {
          this.campaignService.setSaleStatus(this.saleObject);
          this.getUrlById(campaignResolve.product_id, paramsObj);
          return;
        } else if (CampaignService.SALE_QPARAMS.VC) {
          this.getUrlById(campaignResolve.product_id, paramsObj);
          return;
        }
      }
    }
    if (this.urlProductosVida === "/productos-vida") {
      this.seoService.updateTitle(`Productos de Salud Chubb - Banco Guayaquil`);
      this.seoService.updateMetaTags([
        {
          name: "description",
          content: "Productos de Salud Chubb - Tenemos la mejor oferta para ti",
        },
      ]);
      const ramoVida = {
        Ramo_Id: 1,
        Ramo_Name: "Seguros de Vida",
        Is_Leaf: false,
        name: "En caso de fallecimiento por cualquier causa",
        order: "1",
      };
      this.branchSelected = ramoVida;
      this.getSubBranches(ramoVida);
      this.openSubBranch(ramoVida);
    }

    const isFreeSale = this.checkIsFreeSale();
    const isChannelSale = this.checkIsChannelSale();

    this.configSwiper = {
      a11y: {
        enabled: true,
      },
      direction: "horizontal",
      slidesPerView: 1,
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
      },
      keyboard: true,
      mousewheel: false,
      scrollbar: false,
      navigation: false,
      pagination: false,
      watchOverflow: true,
    };
    this.campaignService.sendWaitingMessage(
      `Tenemos las mejores ofertas de seguro para ti.

Chubb siempre contigo.`
    );

    this.getRootBranches();
  }

  getRootBranches() {
    const saleStatusType = this.campaignService.getSaleStatus().type;
    const canalFlow =
      this.campaignService.checkCanalSaleBySaleType(saleStatusType);
    this.portalService.getRootBranches({ flujo: canalFlow }).subscribe(
      (data) => {
        let prefixUrl = this.campaignService.getSaleStatus().prefixUrl;
        this.portalMode = this.portalService.portalMode;
        this.checkPortalMode(this.portalMode);
        if (this.portalMode === this.modeCallCenter) {
          this.campaignService.setSaleStatus(null);
          prefixUrl = CampaignService.PREFIX_SALE.CC;
        }
        const rootUrl = `oferta/${prefixUrl}/pagina-principal`;
        this.branches = data;
        this.location.replaceState(
          rootUrl,
          this.campaignService.getParamsQueryString()
        );
        const productTrackGA = {
          event: "appScreenView",
          screenName: "BG: Portal de Seguros",
          screenPath: `/${rootUrl}`,
          typeSale: this.campaignService.getSaleStatus()?.type || "VL",
          flow_type: prefixUrl || CampaignService.PREFIX_SALE.VL,
          portalMode: this.portalService.portalMode || "ECOMMERCE",
        };
        this.googleAnalyticService.googleTaskManagerPush(productTrackGA);
        this.campaignService.sendLoaderNoInterceptor(false);
        this.hideLoader();
      },
      (err) => {
        const error = err?.error;
        const gaData = {
          event: "system_error",
          error_type: "branches_error",
          flow_type: this.campaignService.getSaleStatus()?.prefixUrl,
          errorData: error,
        };

        this.googleAnalyticService.googleTaskManagerPush(gaData);
      }
    );
  }

  getUrlById(productId: string, paramsObj) {
    this.productService.getProductUrlRemote(productId).subscribe(
      (data) => {
        if (data) {
          if (data?.url) {
            this.router.navigate([data.url], {
              queryParams: paramsObj,
            });
          } else {

          }
        } else {
          this.getRootBranches();
        }
        return data;
      },
      (err) => console.error(err)
    );
  }

  checkPortalMode(mode) {
    if (mode == this.modeCallCenter || mode == this.modeF2F) {
      this.submitSearch();
    }
  }
  formatSpaces(str) {
    return replaceSpaces(str);
  }

  checkIsFreeSale() {
    return this.saleObject.type == "VL";
  }
  checkIsChannelSale() {
    return this.saleObject.type == "VC";
  }

  getProductsFromSearch(data) {
    this.portalService.getProductsFromSearch(data).subscribe(
      (data) => {
        this.productsHome = data;
      },
      (err) => {
        const error = err?.error;
        const gaData = {
          event: "system_error",
          error_type: "products_search_error",
          flow_type: this.campaignService.getSaleStatus()?.prefixUrl,
          errorData: error,
        };

        this.googleAnalyticService.googleTaskManagerPush(gaData);
      }
    );
  }

  submitSearch($event = null) {
    const dataSearch = {
      productName: $event?.payload.searchCriteria || "",
    };
    this.showResults(dataSearch);
  }

  showResults(data) {
    this.getProductsFromSearch(data.productName);
  }

  goBack() {
    this.productsSelected = [];
    this.stepper.previous();
    window.scrollTo(0, 0);
  }
  goNext() {
    this.campaignService.sendLoaderNoInterceptor(false);
    this.stepper.next();
    window.scrollTo(0, 0);
  }

  getRouteFromBranchInput(branchInput) {
    const ramosMap = [
      {
        ramoId: 1,
        ramoName: "Seguros de Vida y Salud",
        url: `oferta/${this.saleObject.prefixUrl}/categorias-vida-salud`,
      },
    ];
    const findRamo = ramosMap.find(
      (c) =>
        c.ramoId == branchInput.Ramo_Id && c.ramoName == branchInput.Ramo_Name
    );
    return findRamo?.url;
  }

  getSubBranches(branchInput) {
    const { Ramo_Id: id_ramo, Ramo_Name: name_ramo } = branchInput;
    this.campaignService.setPortalData({
      ramo_name: this.branchSelected.Ramo_Name,
    });
    const categoriesUrl = this.getRouteFromBranchInput(branchInput);
    if (categoriesUrl) {
      this.router.navigate([categoriesUrl], {
        state: { category: branchInput },
      });
    } else {
      this.portalService
        .getSubBranches({
          id_ramo,
          name_ramo,
        })
        .subscribe((data) => {
          this.campaignService.sendLoaderNoInterceptor(true);
          if (
            this.branchSelected.Is_Leaf &&
            !data[0].modal_Age &&
            data[0].url
          ) {
            this.campaignService.setProductInCampaignData(
              data[0].relatedProducts[0]
            );
            this.router.navigate([data[0].url]);
            return;
          } else if (this.branchSelected.Is_Leaf) {
            this.setProductFromPortal(data[0], true);
          } else {
            this.subBranches = data;
            this.goNext();
          }
          this.loaderService.hide();
        });
    }
  }

  checkProdsFromSubBranchHasModal() {
    return this.productsFromSubBranch.find((e) => e.modal_Age);
  }

  getProdsFromSubBranches(compInput) {
    const {
      Ramo_Id: id_ramo,
      Ramo_Name: name_ramo,
      name: name_coverage,
      order: order_coverage,
    } = compInput;
    this.portalService
      .getProductsFromBranch({
        id_ramo,
        name_ramo,
        name_coverage,
        order_coverage,
      })
      .subscribe((data) => {
        this.campaignService.setPortalData({
          ramo_name: name_ramo,
          coverage_name: name_coverage,
        });
        this.productsFromSubBranch = data;
        if (this.productsFromSubBranch.length > 1) {
          /*this.productsSelected = this.checkHasProducts(
            this.productsFromSubBranch.map((e) => e.relatedProducts[0])
          );*/
          this.goNext();
        } else {
          this.goToProduct(null, [this.productsFromSubBranch[0]]);
        }
      });
  }

  openBranch($event, branch) {
    this.branchSelected = branch;
    this.getSubBranches(this.branchSelected);
  }

  openCompare($event) {
    const checkHasModal = this.checkProdsFromSubBranchHasModal();
    if (checkHasModal) {
      this.openRangeAgeModal();
    } else {
      this.goNext();
    }
  }

  setProductFromPortal(product, toLanding = false) {
    this.campaignService.sendLoaderNoInterceptor(true);
    let params = { ...this.campaignService.getParamsData() };
    const legacyPlanURL = "/select-plan";
    let url = product?.plansUrl || legacyPlanURL;
    if (url.includes(CampaignService.PREFIX_SALE.VL)) {
      url = url.replace(
        CampaignService.PREFIX_SALE.VL,
        this.campaignService.getSaleStatus().prefixUrl
      );
    }
    this.campaignService.setProductInCampaignData(product.relatedProducts[0]);
    if (toLanding) {
      url = product.url;
      return this.router.navigate([url], { queryParams: params });
    } else if (product.prevSteps && !product.customQuote) {
      url = "/previous-steps";
    }
    if (product.url == product?.plansUrl) {
      this.router.navigate([url], { queryParams: params });
    } else {
      this.campaignService.sendLoaderNoInterceptor(false);
      if (url === legacyPlanURL) {
        this.productService
        .getProductsRemote({
          product_Id: product.relatedProducts[0],
          sale_Type: this.campaignService.getSaleStatus().type,
        })
        .subscribe(
          (data) => {
            this.router.navigate([url], { queryParams: params });
            return data;
          },
          (err) => {
            console.error(err);
            const error = err.error || err;
            const errorTrackGA = {
              event: "system_error",
              error_type: "product_error",
              flow_type: this.campaignService.getSaleStatus()?.prefixUrl,
              errorData: error,
            };
            this.googleAnalyticService.googleTaskManagerPush(errorTrackGA);
          }
        );
      } else {
        this.router.navigate([url], { queryParams: params });
      }
    }
  }

  checkHasProducts(inputProds) {
    return inputProds.map((p) => this.productService.getProductByName(p));
  }

  openSubBranch(branch) {
    this.subBranchSelected = branch;
    this.getProdsFromSubBranches({
      ...this.branchSelected,
      ...this.subBranchSelected,
    });
  }

  checkRangeAgeInProduct(prod) {
    const rangeMap = ["SALUD1"];
    const prodInRangeMap = rangeMap.includes(prod.name);
    return prodInRangeMap;
  }

  getRangeAge(range) {
    if (range === "18 - 40") {
      return "40";
    }
    if (range === "41 - 55") {
      return "55";
    }
    if (range === "56 - 65") {
      return "65";
    }
    return;
  }

  goToProduct($event = null, prod) {
    this.campaignService.sendLoaderNoInterceptor(true);
    const campaignData = this.campaignService.getData();
    this.dataService.updatedDataSelection({
      ageRange: this.getRangeAge(campaignData?.range_age_type),
    });
    if (prod.modal_Age && !campaignData?.range_age_type) {
      this.openRangeAgeModal(prod);
    } else if (prod.modal_Age && campaignData.range_age_type == "66 - *") {
      this.errorListService.openModalError(
        this.errorListService.getErrorByCode("rangeAgeNoPermit")
      );
    } else {
      this.setProductFromPortal(
        Array.isArray(prod) ? prod[0] : prod,
        $event?.toLanding
      );
    }
  }

  goToChubb($event) {
    window.open("https://www.chubb.com/ec-es/", "_blank");
  }

  goToPlans($event, prod) {
    this.campaignService.setProductInCampaignData(prod);
    this.router.navigateByUrl("/select-plan");
  }

  scrollToTypeTitle($event, $element) {
    $event.preventDefault();
    $element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
  updateRangeAge(input, prod) {
    const rangeAgeData = {
      range_age_type: input.rangeAge.key,
    };
    let statusRange;
    if (rangeAgeData.range_age_type == "66 - *") {
      statusRange = "rangeAgeInvalid";
    } else {
      statusRange = "rangeAgeValid";
    }
    this.dialog
      .getDialogById("range-age-dialog")
      .close({ message: statusRange, payload: rangeAgeData });
  }

  updateAmountCompare(rangeAgeValue) {
    const amountCompareList = [
      {
        rangeAge: "18 - 40",
        amount: 14.49,
      },
      {
        rangeAge: "41 - 55",
        amount: 24.36,
      },
      {
        rangeAge: "56 - 65",
        amount: 49.37,
      },
    ];
    this.amountCompare = amountCompareList.find(
      (e) => e.rangeAge == rangeAgeValue
    ).amount;
    this.goNext();
  }

  openRangeAgeModal(prod = null) {
    this.campaignService.sendLoaderNoInterceptor(false);
    const dialogRef = this.dialog.open(ModalComponent, {
      id: "range-age-dialog",
      autoFocus: false,
      backdropClass: "backdrop-blur",
      panelClass: "panel-mobile",
      minHeight: "80vh",
      maxHeight: "100vh",

      data: {
        title: "Queremos ofrecerte la mejor cobertura para tí",
        description:
          "Sabemos que tus necesidades son únicas y por eso queremos entregarte un plan exclusivamente para tí. Selecciona tu rango de edad:",
        formName: "range-age-form",
        fields: this.rangeAgesFields,
        submitFn: (input) => this.updateRangeAge(input, prod),
        submitText: "Continuar",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.message == "rangeAgeValid") {
        this.campaignService.sendLoaderNoInterceptor(true);
        const rangeNumber = [
          {
            range: "18 - 40",
            number: "40",
          },
          {
            range: "41 - 55",
            number: "55",
          },
          {
            range: "56 - 65",
            number: "65",
          },
          {
            range: "66 - *",
            number: "66",
          },
        ];
        this.campaignService.setData({
          range_age_type: result.payload.range_age_type,
        });
        const rangeRes = rangeNumber.find(
          (age) => age.range === result.payload.range_age_type
        ).number;
        const data: DataReload = {
          ageRange: rangeRes,
        };
        this.dataService.updatedDataSelection(data);

        if (prod) {
          this.setProductFromPortal(prod);
        } else {
          this.updateAmountCompare(result.payload.range_age_type);
        }
      } else if (result.message == "rangeAgeInvalid") {
        this.errorListService.openModalError(
          this.errorListService.getErrorByCode("rangeAgeNoPermit")
        );
      }
    });
  }

  goToLanding($event, prod) {
    $event.preventDefault();
    this.setProductFromPortal(prod, true);
  }
  openCoverageDetails($event, plan) {
    const configTitle = {
      data: plan,
    };
    $event.preventDefault();
    const dialogRef = this.dialog.open(ModalComponent, {
      id: "dialog-portal-coverage-dateils",
      backdropClass: "backdrop-blur",
      panelClass: "panel-mobile",

      minHeight: "80vh",
      maxHeight: "100vh",
      data: {
        configTitle,
        title: "",
        component: CommonModalCoverageAndExclusionsComponent,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "Schedule Call" || result.message == "Schedule Call") {
        this.openScheduleDialog();
      }
    });
  }

  openScheduleDialog(): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      id: "dialog-schedule-call",
      autoFocus: false,
      backdropClass: "backdrop-blur",
      panelClass: "panel-mobile",
      minHeight: "80vh",
      maxHeight: "100vh",
      data: {
        title: "Agenda una llamada",
        description:
          "Proporciona tus datos y pronto nos pondremos en contacto:",
        formName: "schedule-call-form",
        fields: this.fields,
        bottomText:
          '<p>Al presionar "Enviar", declaro haber leído y acepto el contenido de la cláusula de <a id="consent-of-uses-modal" href="javascript:void(0)" (click)="openModalConsentOfUses()">Tratamiento de Uso de Datos</a> de Chubb Seguros.</p>',
        submitFn: this.sendEmail,
        submitSrvFn: this.sendgridService.sendEmailData,
        submitText: "Enviar",
      },
    });

    dialogRef.componentInstance.parentEvent.subscribe((result) => {});
    dialogRef.afterClosed().subscribe((result) => {
      if (result.message == "success") {
        this.openScheduleResponse(result);
      } else if (result.message == "unknownError") {
        this.errorListService.openModalError();
      }
    });
  }

  openScheduleResponse(typeRes): void {
    var configTitle: TitleModalConfig;
    if (typeRes.message === "success") {
      configTitle = {
        bgclass: "success",
        icon: "check_circle_outline",
        emphasisTitle: "Hemos recibido tu solicitud para agendar una llamada",
      };
    }
    const dialogRef = this.dialog.open(ModalComponent, {
      id: "dialog-schedule-success",
      autoFocus: false,
      backdropClass: "backdrop-blur",
      panelClass: "panel-mobile",
      minHeight: "80vh",
      maxHeight: "100vh",

      data: {
        titleComponent: ResponseTitleComponent,
        configTitle,
        confirmText:
          "Uno de nuestros agentes se pondrá en contacto contigo lo antes posible.",
        confirmActions: {
          confirmLabel: "Aceptar",
        },
      },
    });
  }

  public sendEmail(input) {
    const campaignData = this.campaignService.getData();
    var dataToSend = {
      ...input,
      product: campaignData
        ? this.productService.getProductByName(campaignData.product_id).label
        : "",
    };
    return this.submitSrvFn(dataToSend);
  }
}
